import React, { useState } from 'react';
import { FormControl, InputLabel, Select, MenuItem, Checkbox, FormGroup, FormControlLabel, Button, Grid, Typography } from '@material-ui/core';
import rest from '../../../rest';
import { useSelector } from 'react-redux';
import GetRandomKey from '../../../components/general/genereRandomKey';

function ExportHeure({ closeModal }) {
    const startYear = new Date().getFullYear();
    const [annee, setAnnee] = useState(startYear); // Année actuelle par défaut
    const [regenerer, setRegenerer] = useState(false);
    const manifInfos = useSelector((state) => state.manif.manifInfos);
    const [idManif, setIdManif] = useState('');

    const anneesPossibles = [startYear, startYear - 1, startYear - 2, startYear - 3];

    const handleAnneeChange = (event) => {
        setAnnee(event.target.value);
    };

    const handleRegenererChange = (event) => {
        setRegenerer(event.target.checked);
    };

    const handleSubmit = (event,fileName) => {
        event.preventDefault();
        handleExport(fileName);
    };

    const handleAnnuler = () => {
        closeModal()
    };

    const handleManifChange = (event) => {
        setIdManif(event.target.value);
    };

    const handleExport = async (fileName) => {
        try {
            rest.post(`/statsReact/exportCSV.json`, { fileName, annee, regenerer, idManif }).then((response) => {
                if (response && !response.data.error) {
                    // Create a new link
                    const a = document.createElement('a');
                    a.href = response.data.path;
                    a.download = response.data.fileName;
                    // Action
                    document.body.appendChild(a);
                    a.click();
                    // Remove element from DOM
                    document.body.removeChild(a);
                }
            });
        } catch (error) {
            console.error(`Erreur lors de l'export :`, error);
        }
    };

    return (
        <form onSubmit={(e) => handleSubmit(e, 'ExtractionHeures')}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography style={{ marginBottom: '25px' }}>
                        Ce formulaire permet d'exporter par événements le nombre d'heures que chaque bénévole a effectué
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <FormControl fullWidth>
                        <InputLabel>Année</InputLabel>
                        <Select value={annee} onChange={handleAnneeChange}>
                            {anneesPossibles.map((a) => (
                                <MenuItem key={a} value={a}>
                                    {a}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                {manifInfos.NbManif > 1 &&
                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <InputLabel>Manifestation</InputLabel>
                            <Select
                                value={idManif}
                                onChange={handleManifChange}
                            >
                                <MenuItem value="">Toutes</MenuItem>
                                {manifInfos.tManifId.map((manifId, key) => (
                                    <MenuItem key={GetRandomKey(8)} value={manifId}>
                                        {manifInfos.tManifNom[key]}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>}
                <Grid item xs={12}>
                    <FormGroup>
                        <FormControlLabel
                            control={<Checkbox checked={regenerer} onChange={handleRegenererChange} />}
                            label="Régénérer"
                        />
                    </FormGroup>
                </Grid>
                <Grid item xs={12}>
                    <Grid container justifyContent="flex-end" spacing={2}>
                        <Grid item>
                            <Button type="submit" color="primary" variant="outlined">
                                Exporter
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button type="button" variant="outlined" color="primary" onClick={handleAnnuler}>
                                Annuler
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </form>
    );
}

export default ExportHeure;